import { reportData } from '@/api/report';

export const ACTIVITY_LANDING_REPORT_TYPE = 28;

// popup_type：承接页绑定链路中出现的弹窗类型。
export const ACTIVITY_LANDING_POPUP_TYPE = {
  // 游戏账号密码绑定弹窗。
  ACCOUNT: 1,
  // 手机验证码绑定弹窗。
  MOBILE: 2,
  // 账号校验成功后，需要用户确认角色的弹窗。
  CONFIRM_ROLE: 3,
  // 使用平台已有账号时，第一步让用户确认当前账号的弹窗。
  CONFIRM_ACCOUNT: 4,
};

// bind_result：绑定类动作的服务端处理结果。
export const ACTIVITY_LANDING_BIND_RESULT = {
  // 绑定成功。
  SUCCESS: 1,
  // 绑定失败。
  FAIL: 2,
};

// btn_type：承接页绑定链路中的按钮点击类型。
export const ACTIVITY_LANDING_BTN_TYPE = {
  // 更换账号。
  CHANGE_ACCOUNT: 1,
  // 绑定游戏账号按钮。
  BIND_GAME_ACCOUNT: 2,
  // 切换到手机短信账号。
  SWITCH_MOBILE: 3,
  // 忘记账号密码。
  FORGET_ACCOUNT: 4,
  // 没有游戏账号。
  NO_ACCOUNT: 5,
  // 切换账号密码。
  SWITCH_PASSWORD: 6,
  // 确认绑定。
  CONFIRM_BIND: 7,
};

// 承接页埋点统一入口，缺少 hash_id 时不上报，避免产生无归属数据。
export function reportActivityLandingData(data = {}) {
  if (!data.hash_id) return Promise.resolve();
  try {
    return Promise.resolve(
      reportData({
        type: ACTIVITY_LANDING_REPORT_TYPE,
        ...data,
      }),
    ).catch(() => {});
  } catch (error) {
    return Promise.resolve();
  }
}
